import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/AnchorButton"
import styles from "./CTASignUpLong.module.scss"

const CTASignUpLong = props => {
  return (
    <section className={styles.section + " container-fluid bg-secondary"}>
      <div className="row ml-0 mr-0">
        <Wrapper className="w-100" gap="outer">
          <WrapperInner className={"row"}>
            <div className="col-12">
              <div className={"text-center text-lg-left m-auto text-primary"}>
                <h3>
                  <TopTitle
                    content="TRY ASSERTIV NOW"
                    textColor="text-primary"
                  />
                  <div
                    className={
                      styles.title +
                      " proxima-nova--extra-bold fs-30pt fs-lg-40pt fs-xl-60pt"
                    }
                  >
                    SEE A DEMO
                  </div>
                </h3>
                <p
                  className={
                    styles.description + " proxima-nova--light fs-18pt"
                  }
                >
                  For a secure, simple way of managing access to your company’s
                  digital tools, while preventing security breaches.
                </p>
                <AnchorButton
                  href="https://app.engineid.com/register"
                  content="CREATE YOUR ACCOUNT"
                  className={styles.button}
                />
              </div>
            </div>
          </WrapperInner>
        </Wrapper>
      </div>
    </section>
  )
}

export default CTASignUpLong
